/**
 * @generated SignedSource<<87c3df7e0d4ac3e51cf8d20183909cb9>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useChildrenPreferenceCriteria_query$data = {
  readonly currentUser: {
    readonly childrenPreferenceCriteria: {
      readonly nodes: ReadonlyArray<{
        readonly childrenPreferenceId: any;
      } | null | undefined>;
    };
  } | null | undefined;
  readonly " $fragmentType": "useChildrenPreferenceCriteria_query";
};
export type useChildrenPreferenceCriteria_query$key = {
  readonly " $data"?: useChildrenPreferenceCriteria_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"useChildrenPreferenceCriteria_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useChildrenPreferenceCriteria_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "currentUser",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "orderBy",
              "value": [
                "CHILDREN_PREFERENCE_BY_CHILDREN_PREFERENCE_ID__SEQUENCE_ASC"
              ]
            }
          ],
          "concreteType": "ChildrenPreferenceCriterionConnection",
          "kind": "LinkedField",
          "name": "childrenPreferenceCriteria",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ChildrenPreferenceCriterion",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "childrenPreferenceId",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "childrenPreferenceCriteria(orderBy:[\"CHILDREN_PREFERENCE_BY_CHILDREN_PREFERENCE_ID__SEQUENCE_ASC\"])"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "8f3d4a2eb2139ce20ce49918d21b75e1";

export default node;
